export const ApplicatinStatus: string[] = [
    "APPLIED",
    "ACCEPTED",
    "REVIEW",
    "DECLINED"
];

export const CertLevels: string[] = [
    "MSC", 
    "PHD", 
    "HIGHSCHOOL", 
    "BSC", 
    "DEGREE", 
    "DOCTORATE"
];

export const BlogCategories: string[] = [
    'TRANSPORTATION',
    'ACCOMODATION',
    'HEALTH',
    'CONSULTATION',
    'SERVICE',
    'FOOD',
    'LIFESTYLE',
    'BUSINESS',
    'FASHION',
    'TRAVEL',
    'GENERAL'
];

export const BlogStatusOptions: string[] = [
    'DRAFT',
    'PUBLISHED',
    'UNPUBLISHED'
];